<div
  [ngClass]="{ 'font-translate': decreaseFont() }"
  class="d-block d-sm-none mobile-bg py-3"
>
  <ul>
    <li class="">
      <a
        class="nav-link"
        href="https://www.tn.gov/state-services.html"
        target="_blank"
        [attr.aria-label]="'FOOTER_LINK1' | globalTranslate"
      >
        @if (currentLang !== 'en' && globalLang === null) {
        {{ "FOOTER_LINK1" | globalTranslate }} {{ "TN.gov" }}
        } @else {
        {{ "TN.gov" }} {{ "FOOTER_LINK1" | globalTranslate }}
        }
      </a>
      <hr />
    </li>

    <li class="">
      <a
        class="nav-link"
        href="https://www.tn.gov/directory.html"
        target="_blank"
        [attr.aria-label]="'FOOTER_LINK2' | globalTranslate"
      >
        @if (currentLang !== 'en' && globalLang === null) {
        {{ "FOOTER_LINK2" | globalTranslate }} {{ "TN.gov" }}
        } @else {
        {{ "TN.gov" }} {{ "FOOTER_LINK2" | globalTranslate }}
        }
      </a>
      <hr />
    </li>

    <li class="">
      <a
        class="nav-link"
        href="https://www.tn.gov/transparenttn.html"
        target="_blank"
        [attr.aria-label]="'FOOTER_LINK3' | globalTranslate"
      >
        @if (currentLang !== 'en' && globalLang === null) {
        {{ "TN" }} {{ "FOOTER_LINK3" | globalTranslate }}
        } @else {
        {{ "FOOTER_LINK3" | globalTranslate }} {{ "TN" }}
        }
      </a>
      <hr />
    </li>

    <li class="">
      <a
        class="nav-link"
        href="https://www.tn.gov/humanrights/file-a-discrimination-complaint/title-vi1/title-vi-disclaimer.html"
        target="_blank"
        [attr.aria-label]="('FOOTER_LINK4' | globalTranslate) + 'VI'"
        >{{ "FOOTER_LINK4" | globalTranslate }} {{ "VI" }}</a
      >
      <hr />
    </li>
    <li class="">
      <a
        class="nav-link"
        tabindex="0"
        (click)="openAnalyticsPolicy()"
        [attr.aria-label]="'FOOTER_LINK5' | globalTranslate"
        >{{ "FOOTER_LINK5" | globalTranslate }}</a
      >
      <hr />
    </li>
    <li class="">
      <a
        class="nav-link"
        href="https://www.tn.gov/about-tn/state-symbols.html"
        target="_blank"
        [attr.aria-label]="'FOOTER_LINK6' | globalTranslate"
        >{{ "FOOTER_LINK6" | globalTranslate }}</a
      >
      <hr />
    </li>
    <li class="">
      <a
        class="nav-link"
        href="https://www.tn.gov/web-policies/privacy-statement.html"
        target="_blank"
        [attr.aria-label]="'FOOTER_LINK7' | globalTranslate"
        >{{ "FOOTER_LINK7" | globalTranslate }}</a
      >
      <hr />
    </li>
    <li class="">
      <a
        class="nav-link"
        href="https://www.tn.gov/web-policies/accessibility.html"
        target="_blank"
        [attr.aria-label]="'FOOTER_LINK8' | globalTranslate"
        >{{ "FOOTER_LINK8" | globalTranslate }}</a
      >
      <hr />
    </li>
    <li class="">
      <a
        class="nav-link"
        href="https://help.tn.gov/tn"
        target="_blank"
        [attr.aria-label]="'FOOTER_LINK9' | globalTranslate"
        >{{ "FOOTER_LINK9" | globalTranslate }}</a
      >
      <hr />
    </li>
    <li class="">
      <a
        class="nav-link"
        href="https://www.tn.gov/survey.html"
        target="_blank"
        [attr.aria-label]="'FOOTER_LINK10' | globalTranslate"
        >{{ "FOOTER_LINK10" | globalTranslate }}</a
      >
    </li>
  </ul>
</div>

<footer class="footer-root">
  <div class="d-block d-sm-none">
    <div class="row extra-space"></div>
  </div>

  <div class="d-sm-block">
    <div class="bg white">
      <div class="container">
        <div class="d-flex justify-content-between">
          <div class="my-2">
            <div>
              <img
                alt=""
                aria-hidden="true"
                class="img-responsive img-book"
                src="../../../assets/images/Icons/icons-document-text-outline.svg"
              />
              <a
                class="page-info btn-link"
                href="https://www.tn.gov/tenncare/members-applicants/how-do-i-apply-for-tenncare.html"
                target="_blank"
                [attr.aria-label]="'PAPER_APPLICATION' | globalTranslate"
              >
                {{ "PAPER_APPLICATION" | globalTranslate }}
              </a>
            </div>
          </div>
          <div class="my-2">
            <img
              alt="phone"
              aria-hidden="true"
              role="presentation"
              class="img-responsive img-book"
              src="../../../assets/images/Icons/icons-call-outline-1.svg"
            />
            <span class="page-info">&nbsp;{{ phoneNumber }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    id="footer-top"
    aria-hidden="true"
    class="d-flex flex-column align-items-center tn-footer-logo"
  >
    <img
      _ngcontent-cyx-c5=""
      alt="TN-Footer-Logo"
      src="../../assets/images/Illio.NashStarsFooterIcon.svg"
    />
  </div>

  <div class="d-block d-sm-none">
    <div class="row ft-btm-mobile"></div>
  </div>

  <div class="ft-btm d-none d-sm-block">
    <div class="container pt-1">
      <div class="d-none d-sm-block">
        <nav
          id="footer-bottom"
          [ngClass]="{ 'font-translate': decreaseFont() }"
          class="navbar navbar-light navbar-expand-md"
        >
          <ul class="nav navbar-nav justify-content-start">
            <li class="">
              <a
                class="nav-link"
                href="https://www.tn.gov/state-services.html"
                target="_blank"
                [attr.aria-label]="'FOOTER_LINK1' | globalTranslate"
              >
                @if (currentLang !== 'en' && globalLang === null) {
                {{ "FOOTER_LINK1" | globalTranslate }} {{ "TN.gov" }}
                } @else {
                {{ "TN.gov" }} {{ "FOOTER_LINK1" | globalTranslate }}
                }
              </a>
            </li>

            <li class="">
              <a
                class="nav-link"
                href="https://www.tn.gov/directory.html"
                target="_blank"
                [attr.aria-label]="'FOOTER_LINK2' | globalTranslate"
              >
                @if (currentLang !== 'en' && globalLang === null) {
                {{ "FOOTER_LINK2" | globalTranslate }} {{ "TN.gov" }}
                } @else {
                {{ "TN.gov" }} {{ "FOOTER_LINK2" | globalTranslate }}
                }
              </a>
            </li>

            <li class="">
              <a
                class="nav-link"
                href="https://www.tn.gov/transparenttn.html"
                target="_blank"
                [attr.aria-label]="'FOOTER_LINK3' | globalTranslate"
              >
                @if (currentLang !== 'en' && globalLang === null) {
                {{ "TN" }} {{ "FOOTER_LINK3" | globalTranslate }}
                } @else {
                {{ "FOOTER_LINK3" | globalTranslate }} {{ "TN" }}
                }
              </a>
            </li>

            <li class="">
              <a
                class="nav-link"
                href="https://www.tn.gov/humanrights/file-a-discrimination-complaint/title-vi1/title-vi-disclaimer.html"
                target="_blank"
                [attr.aria-label]="('FOOTER_LINK4' | globalTranslate) + 'VI'"
                >{{ "FOOTER_LINK4" | globalTranslate }} {{ "VI" }}</a
              >
            </li>
            <li class="">
              <a
                class="nav-link"
                tabindex="0"
                (click)="openAnalyticsPolicy()"
                [attr.aria-label]="'FOOTER_LINK5' | globalTranslate"
                >{{ "FOOTER_LINK5" | globalTranslate }}</a
              >
            </li>
          </ul>
          <ul class="nav navbar-nav ms-auto justify-content-end">
            <li class="">
              <a
                class="nav-link"
                href="https://www.tn.gov/about-tn/state-symbols.html"
                target="_blank"
                [attr.aria-label]="'FOOTER_LINK6' | globalTranslate"
                >{{ "FOOTER_LINK6" | globalTranslate }}</a
              >
            </li>
            <li class="">
              <a
                class="nav-link"
                href="https://www.tn.gov/web-policies/privacy-statement.html"
                target="_blank"
                [attr.aria-label]="'FOOTER_LINK7' | globalTranslate"
                >{{ "FOOTER_LINK7" | globalTranslate }}</a
              >
            </li>
            <li class="">
              <a
                class="nav-link"
                href="https://www.tn.gov/web-policies/accessibility.html"
                target="_blank"
                [attr.aria-label]="'FOOTER_LINK8' | globalTranslate"
                >{{ "FOOTER_LINK8" | globalTranslate }}</a
              >
            </li>
            <li class="">
              <a
                class="nav-link"
                href="https://help.tn.gov/tn"
                target="_blank"
                [attr.aria-label]="'FOOTER_LINK9' | globalTranslate"
                >{{ "FOOTER_LINK9" | globalTranslate }}
              </a>
            </li>
            <li class="">
              <a
                class="nav-link"
                href="https://www.tn.gov/survey.html"
                target="_blank"
                [attr.aria-label]="'FOOTER_LINK10' | globalTranslate"
                >{{ "FOOTER_LINK10" | globalTranslate }}</a
              >
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</footer>